/**
 * ループの実行状態を管理
 */
export class LoopStateManager {
  // ループノードごとの実行状態を保持
  private loopStates = new Map<any, LoopState>()
  
  /**
   * ループの実行状態を取得または作成
   */
  getOrCreateLoopState(loopNode: any): LoopState {
    if (!this.loopStates.has(loopNode)) {
      this.loopStates.set(loopNode, {
        initialized: false,
        executing: false,
        completed: false,
      })
    }
    return this.loopStates.get(loopNode)!
  }
  
  /**
   * ループを初期化済みとしてマーク
   */
  markInitialized(loopNode: any): void {
    const state = this.getOrCreateLoopState(loopNode)
    state.initialized = true
    state.executing = true
  }
  
  /**
   * ループを完了済みとしてマーク
   */
  markCompleted(loopNode: any): void {
    const state = this.getOrCreateLoopState(loopNode)
    state.executing = false
    state.completed = true
  }
  
  /**
   * ループの完了状態をリセット（ネストしたループ用）
   */
  resetCompleted(loopNode: any): void {
    const state = this.loopStates.get(loopNode)
    if (state) {
      state.completed = false
      state.initialized = false
      state.executing = false
    }
  }
  
  /**
   * ループが初期化済みかチェック
   */
  isInitialized(loopNode: any): boolean {
    const state = this.loopStates.get(loopNode)
    return state?.initialized ?? false
  }
  
  /**
   * ループが完了済みかチェック
   */
  isCompleted(loopNode: any): boolean {
    const state = this.loopStates.get(loopNode)
    return state?.completed ?? false
  }
  
  /**
   * 全ての状態をクリア
   */
  clear(): void {
    this.loopStates.clear()
  }
}

interface LoopState {
  initialized: boolean
  executing: boolean
  completed: boolean
}